export default __webpack_public_path__ + "static/media/no-results.79ef757d.svg";